import type { SiteFeaturesResponse } from './apiModels';
import {
  SITE_FEATURE_FLAGS,
  type SiteFeatureFlag,
  type SiteFeatures,
  type SiteFeaturesState,
} from './domainModels';

/**
 * Narrow the wire map to the known flags.
 *
 * Only a literal `true` is on, matching the backend's "unset means off": anything
 * missing or malformed must not switch a feature on for players.
 */
const toFeatures = (wire: Readonly<Record<string, unknown>> | undefined): SiteFeatures =>
  SITE_FEATURE_FLAGS.reduce(
    (features, flag) => ({ ...features, [flag]: wire?.[flag] === true }),
    {} as Record<SiteFeatureFlag, boolean>
  );

export function toSiteFeaturesState(response: SiteFeaturesResponse): SiteFeaturesState {
  return {
    siteId: response.siteId,
    features: toFeatures(response.features),
    updatedAt: response.updatedAt ?? null,
    updatedBy: response.updatedBy ?? null,
  };
}
